import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import * as dayjs from 'dayjs';
import {ConfigurationService} from '../../../services/common/configuration/configuration.service';

@Component({
  selector: 'alarms-search',
  templateUrl: './alarms-search.component.html',
  styleUrls: ['./alarms-search.component.scss']
})
export class AlarmsSearchComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AlarmsSearchComponent>,
              @Inject(MAT_DIALOG_DATA) public search: any,
              private configurationService: ConfigurationService) {
  }

  type: any;

  onApply = new EventEmitter();
  datePickerOptions: any;

  ngOnInit(): void {

    if (!this.search.startDate){
      this.getDefaultSearchParameters();
      this.search.alarmsTime = 'noDates';
    }

    if (this.search.type === 'active' && !this.search.isAcknowledged) {
      this.search.isAcknowledged = 0;
    }

    this.type = this.search.type;
    this.datePickerOptions = this.configurationService.getDatePickerOptions();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.generateStartDay();
    this.generateEndDay();

    this.dialogRef.close();
    this.onApply.emit(this.search);
  }

  generateStartDay(): void {
    if (!this.search.alarmsTime) {
      this.search.startDate = '';
      return;
    }

    switch (this.search.alarmsTime) {
      case 'noDates':
        this.search.startDate = '';
        break;

      case 'betweenDates':
        if (this.search.startDate){
          break;
        }
        this.search.startDate = this.calculateStartDay(1);
        break;
      case 'last30Days':
        this.search.startDate = this.calculateStartDay(30);
        break;
      case 'last7Days':
        this.search.startDate = this.calculateStartDay(7);
        break;
      case 'last24Hours':
        this.search.startDate = this.calculateStartDay(1);
        break;
    }
  }

  calculateStartDay(daysAgo: number): string {
    return dayjs().subtract(daysAgo, 'days').toISOString();
  }

  getDefaultSearchParameters(): any {
    this.search.date = {
      startDate: dayjs().subtract(1, 'days'),
      endDate: dayjs(),
    };
  }

  generateEndDay(): void {

    if (!this.search.alarmsTime) {
      this.search.endDate = '';
      return;
    }

    if (this.search.alarmsTime !== 'betweenDates') {
      this.search.endDate = '';
      return;
    }

    if (!this.search.endDate){
      this.search.endDate = dayjs().toISOString();
    }
  }


  onDatePick($event: any): void {
    this.search.startDate = $event.startDate.toISOString();
    this.search.endDate = $event.endDate.toISOString();
  }
}
